module.exports = __webpack_public_path__ + "static/bernard-hermant-X-Bu9X6gok0-unsplashBackground-77aa38d660c6a26d61a7ea8d94848249.jpg";